/*
 * VideoConf Messages
 *
 * This contains all the text for the VideoConf component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.VideoConf.header',
    defaultMessage: 'Video Conferencing',
  },
  showProvider: {
    id: 'app.components.VideoConf.showProvider',
    defaultMessage: '{provider, select, none {You have not selected a provider for video conferencing} other {You are using {name} for video conferencing}} ',
  },
  selectProvider: {
    id: 'app.components.VideoConf.selectProvider',
    defaultMessage: 'Select a provider for video conferencing: ',
  },
  howTo: {
    id: 'app.components.VideoConf.howTo',
    defaultMessage: 'Open \'Options - Overview of Meetings\' to check which meetings have video conferencing already and to add video conferencing.',
  },
  none: {
    id: 'app.common.none',
    defaultMessage: 'None',
  },
  googleMeet: {
    id: 'app.components.VideoConf.googleMeet',
    defaultMessage: 'Google Meet',
  },
  msTeams: {
    id: 'app.components.VideoConf.msTeams',
    defaultMessage: 'Microsoft Teams',
  },
  zoom: {
    id: 'app.components.VideoConf.zoom',
    defaultMessage: 'Zoom',
  },
  confirmRemove: {
    id: 'app.components.VideoConf.confirmRemove',
    defaultMessage: "Remove video conference for ''{title}''?",
  },
  videoLink: {
    id: 'app.components.VideoConf.videoLink',
    defaultMessage: 'Video Link',
  },
  addVideo: {
    id: 'app.components.VideoConf.addVideo',
    defaultMessage: 'Add Video Conference',
  },
  confirmSignOut: {
    id: 'app.components.VideoConf.confirmSignOut',
    defaultMessage: 'Sign Out from {name}?',
  },
  signOut: {
    id: 'app.components.VideoConf.signOut',
    defaultMessage: 'Sign Out',
  },
  notSignedIn: {
    id: 'app.components.VideoConf.notSignedIn',
    defaultMessage: 'Not signed in',
  },
  canNotSignIn: {
    id: 'app.components.VideoConf.canNotSignIn',
    defaultMessage: 'Cannot sign in on {provider, select, 1 {Google} 2 {Microsoft} other {??}}',
  },
  differentProvider: {
    id: 'app.components.VideoConf.differentProvider',
    defaultMessage: 'You are not signed in to the provider of this video conference',
  },
  eventDescription: {
    id: 'app.components.VideoConf.eventDescription',
    defaultMessage: 'Parent Meeting with {parents}',
  },
  joinTeamsMeeting: {
    id: 'app.components.VideoConf.joinTeamsMeeting',
    defaultMessage: 'Join Teams Meeting',
  },
  popup_closed_by_user: {
    id: 'app.components.VideoConf.userCancelled',
    defaultMessage: 'Cancelled by user',
  },
  popup_blocked_by_browser: {
    id: 'app.components.VideoConf.browserBlocked',
    defaultMessage: 'Pop-up blocked by browser',
  },
  popup_window_error: {
    id: 'app.components.VideoConf.browserBlocked',
    defaultMessage: 'Pop-up blocked by browser',
  },
  user_cancelled: {
    id: 'app.components.VideoConf.userCancelled',
    defaultMessage: 'Cancelled by user',
  },
  access_denied: {
    id: 'app.components.VideoConf.accessDenied',
    defaultMessage: 'Required permission denied',
  },
});
